import { Component, h, Prop } from '@stencil/core';
import state from '@ugc-store';
import { IGaEvent } from './interface';
import { Share } from '../../icons';
import { FontType } from '@ugc-utils/utils';

@Component({
  tag: 'ugc-share',
  shadow: false,
})
export class UgcShare {
  @Prop() type: 'icon' | 'button' = 'icon';
  @Prop() gaEvent: IGaEvent = {
    'data-ga-event-name': '',
    'data-ga-content-type': '',
    'data-ga-location-detail': '',
  };
  @Prop() sid: string = '';
  @Prop() position: string = 'bottom';
  @Prop() shareUrl: string = '';
  @Prop() fontType: FontType = FontType.large;
  @Prop() shareWidgetLayer?: number;

  handleShare = () => {
    state.isShowShareModal = true;
    state.shareUrl = this.shareUrl;
  };

  render() {
    const {
      qnaStaticLanguage: { IDS_UGC_REVIEWS_SHARE_TEXT },
      isDesktop,
    } = state;
    const isLargeType = this.fontType === FontType.large;
    if (isDesktop) {
      return (
        <share-button
          class="rewards-share-button qna-share-button"
          widget-layer={this.shareWidgetLayer || 1}
          sbid={this.sid}
          text={isLargeType ? IDS_UGC_REVIEWS_SHARE_TEXT : ''}
          text-size={16}
          text-color="#f38a00"
          text-weight={700}
          url={this.shareUrl}
          icon-size={isLargeType ? '24' : '16'}
          icon-color="#f38a00"
          position={this.position}
          {...this.gaEvent}
        />
      );
    }

    if (this.type === 'button')
      return (
        <ugc-button type="text" customStyle={{ padding: '16px 0', fontWeight: 400 }}>
          <a
            class="flex-row-start-center"
            onClick={this.handleShare.bind(this)}
            {...this.gaEvent}
            data-url={this.shareUrl}
          >
            <Share width="24" height="24" fill={'#333'} />
            <span class="fs-16 mlr-8">{IDS_UGC_REVIEWS_SHARE_TEXT}</span>
          </a>
        </ugc-button>
      );

    return (
      <a
        class="flex-row-center-center"
        onClick={this.handleShare.bind(this)}
        {...this.gaEvent}
        data-url={this.shareUrl}
      >
        <Share fill={'#F38A00'} />
      </a>
    );
  }
}
